module.exports = {
  text: `Битва — всегда насмерть для них, посему такова она и для вас`,
  author: `Эльминстер`,
}
